import { makeStyles } from "@material-ui/core";

const useTvWeeklyScheduleStyles = makeStyles(theme => ({
    button: {
        margin: 5
    },
    buttonLabel: {
        fontFamily: "OpenSans",
        fontWeight: 400,
        fontSize: "0.92rem"
    }
}));

export default useTvWeeklyScheduleStyles;